"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const generic_1 = __importDefault(require("./generic"));
const addAttrs = {
    strokeWidth: '1',
    strokeLinecap: 'butt',
    vectorEffect: 'non-scaling-stroke'
};
const IconbuttonAdd = props => (jsx_runtime_1.jsx(generic_1.default, Object.assign({}, props, { variant: "outline" }, { children: jsx_runtime_1.jsxs("svg", Object.assign({ viewBox: "0 0 100 100", "aria-hidden": "true" }, { children: [jsx_runtime_1.jsx("line", Object.assign({}, addAttrs, { x1: "30", x2: "70", y1: "50", y2: "50" }), void 0),
            jsx_runtime_1.jsx("line", Object.assign({}, addAttrs, { x1: "50", x2: "50", y1: "30", y2: "70" }), void 0)] }), void 0) }), void 0));
IconbuttonAdd.propTypes = {
    onClick: prop_types_1.default.func.isRequired,
    label: prop_types_1.default.string,
    buttonRef: prop_types_1.default.func,
    disabled: prop_types_1.default.bool
};
IconbuttonAdd.defaultProps = {
    label: 'Add',
    disabled: false,
    buttonRef: null
};
exports.default = IconbuttonAdd;
//# sourceMappingURL=add.js.map